import React, { useEffect } from 'react';
import './ChallengeDeclinedToast.css';

interface ChallengeDeclinedToastProps {
  challengedUsername: string;
  reason: 'declined' | 'timeout';
  onClose: () => void;
}

const ChallengeDeclinedToast: React.FC<ChallengeDeclinedToastProps> = ({
  challengedUsername,
  reason,
  onClose
}) => {
  useEffect(() => {
    // Auto-close after 5 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="challenge-declined-toast">
      <div className="challenge-declined-content">
        <div className="challenge-declined-header">
          <span className="declined-icon">ℹ️</span>
          <h3>Challenge Declined</h3>
        </div>
        <p className="challenge-declined-message">
          Your challenge to <strong>{challengedUsername}</strong> was{' '}
          {reason === 'timeout' ? 'declined (timeout)' : 'declined'}.
        </p>
        <button className="challenge-declined-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ChallengeDeclinedToast;








